<script setup>
// Share of the whole portfolio as a bar on a 0–100 % scale (docs/analytics/SPEC.md, decision 14):
// the same width means the same share in every block.
defineProps({
  percent: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    default: '#64748b',
  },
  thin: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <span
    class="hidden flex-1 overflow-hidden rounded-full bg-slate-800 sm:block"
    :class="thin ? 'h-1 opacity-60' : 'h-1.5'"
    aria-hidden="true"
  >
    <span
      class="block h-full rounded-full"
      :style="{ width: `${Math.min(Math.max(percent, 0), 100)}%`, backgroundColor: color }"
    />
  </span>
</template>
